import Component from "@ember/component";
import $ from "jquery";
import discourseComputed from "discourse-common/utils/decorators";
export default Component.extend(dt7948.p({
  tagName: "input",
  type: "radio",
  attributeBindings: ["name", "type", "value", "checked:checked", "disabled:disabled"],
  click() {
    const value = $(this.element).val();
    if (this.onChange) {
      this.onChange(value);
    } else {
      if (this.selection === value) {
        this.set("selection", undefined);
      }
      this.set("selection", value);
    }
  },
  checked(value, selection) {
    return value === selection;
  }
}, [["method", "checked", [discourseComputed("value", "selection")]]]));